const assets = {
  CAMERA: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Camera-1.png',
  CROSS_ICON: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Cross.svg',
  ERROR_ICON: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/ErrorIcon-1.png',
  FOCUS: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Focus.png',
  KNOW_MORE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/KnowMore.png',
  PHONE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Phone.png',
  SIGNAL: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Signal.png',
  VIDEO: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Video.png',
  WEBSITE: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Website.png',
  FOLLOW_US: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/FollowUs.png',
  CONTACT_US: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/ContactUs.png',
  LOADER_IMAGE_URL: 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Enno_Loader.webp',
} as const;
/**
 * Backend camera indicators for detecting the back camera
 */
export const BACK_INDICATORS: string[] = [
  // English (universal baseline)
  'back', 'rear', 'environment', 'main',

  // Chinese (Simplified) - Already present, unchanged
  '后置', '后面', '后置相机',

  // Chinese (Traditional) - Taiwan, Hong Kong
  '後置', '後面', '後置相機', '主鏡頭',

  // Italian (Italy) - Expanding from 'posteriore'
  'posteriore', 'retro', 'dietro', 'principale',

  // German (Deutsch) - Already present, unchanged
  'rück', 'hinten', 'haupt',

  // Spanish (Argentina) - Expanding from 'trasera', 'posterior'
  'trasera', 'posterior', 'atrás', 'trasero', 'principal',

  // Spanish (Mexico)
  'trasera', 'posterior', 'atrás', 'principal',

  // Spanish (Spain)
  'trasera', 'posterior', 'atrás', 'principal',

  // Hindi (India) - Already present, unchanged
  'पीछे', 'बैक', 'मुख्य', // Pīche, Back, Mukhya

  // Polish (Polski) - Already present, unchanged
  'tył', 'tylny', 'główny',

  // Portuguese (Brazil) - Expanding from 'traseira', 'posterior'
  'traseira', 'posterior', 'trás', 'de trás', 'principal',

  // Portuguese (Portugal)
  'traseira', 'posterior', 'traseiro', 'principal',

  // Thai (Thailand) - Expanding from 'ด้านหลัง'
  'ด้านหลัง', 'กล้องด้านหลัง', 'หลัง', '背面', 'หลัก',

  // French (France)
  'arrière', 'derrière', 'principal', 'dorsale',

  // French (Canada)
  'arrière', 'derrière', 'principal', 'dorsale',

  // Japanese (Japan)
  '背面', '後面', 'バック', 'メイン', '裏面',

  // Korean (South Korea)
  '후면', '뒷면', '백', '메인', '주',

  // Russian (Russia)
  'задняя', 'сзади', 'основная', 'тыльная',

  // Dutch (Netherlands)
  'achter', 'achterkant', 'hoofd', 'primaire',

  // Dutch (Belgium)
  'achter', 'achterkant', 'hoofd', 'primaire',

  // Swedish (Sweden)
  'bak', 'bakre', 'huvud', 'primär',

  // Norwegian (Norway)
  'bak', 'bakre', 'hoved', 'primær',

  // Danish (Denmark)
  'bag', 'bageste', 'hoved', 'primær',

  // Finnish (Finland)
  'taka', 'takana', 'pää', 'ensisijainen',

  // Turkish (Turkey)
  'arka', 'arkada', 'ana', 'asıl',

  // Arabic (Saudi Arabia, UAE)
  'خلفية', 'خلف', 'رئيسية', 'أساسية',

  // Hebrew (Israel)
  'אחורי', 'אחור', 'ראשי', 'עיקרי',

  // Czech (Czech Republic)
  'zadní', 'vzadu', 'hlavní', 'primární',

  // Slovak (Slovakia)
  'zadný', 'vzadu', 'hlavný', 'primárny',

  // Hungarian (Hungary)
  'hátsó', 'hátul', 'fő', 'elsődleges',

  // Greek (Greece)
  'πίσω', 'οπίσθια', 'κύρια', 'κεντρική',

  // Romanian (Romania)
  'spate', 'din spate', 'principală', 'primară',

  // Bulgarian (Bulgaria)
  'задна', 'отзад', 'основна', 'главна',

  // Croatian (Croatia)
  'stražnja', 'straga', 'glavna', 'primarna',

  // Serbian (Serbia)
  'zadnja', 'pozadi', 'glavna', 'primarna',

  // Ukrainian (Ukraine)
  'задня', 'ззаду', 'основна', 'головна',

  // Slovenian (Slovenia)
  'zadnja', 'zadaj', 'glavna', 'primarna',

  // Lithuanian (Lithuania)
  'galinė', 'gale', 'pagrindinė', 'pirminė',

  // Latvian (Latvia)
  'aizmugurējā', 'aizmugurē', 'galvenā', 'primārā',

  // Estonian (Estonia)
  'tagumine', 'taga', 'peamine', 'esmane',

  // Icelandic (Iceland)
  'aftur', 'aftari', 'aðal', 'frumlega',

  // Catalan (Spain)
  'posterior', 'darrere', 'principal', 'primària',

  // Basque (Spain)
  'atzekoa', 'atzean', 'nagusia', 'lehenengo',

  // Galician (Spain)
  'traseira', 'detrás', 'principal', 'primaria',

  // Welsh (UK)
  'cefn', 'tu ôl', 'prif', 'sylfaenol',

  // Irish (Ireland)
  'cúil', 'ar chúl', 'príomh', 'bunúsach',

  // Scottish Gaelic (UK)
  'cùil', 'air chùl', 'prìomh', 'bunaiteach',

  // Maltese (Malta)
  'ta\' wara', 'fuq wara', 'ewlieni', 'primarju',

  // Vietnamese (Vietnam)
  'sau', 'phía sau', 'chính', 'chủ yếu', 'camera mặt sau',

  // Indonesian (Indonesia)
  'belakang', 'di belakang', 'utama', 'primer',

  // Malay (Malaysia)
  'belakang', 'di belakang', 'utama', 'primer',

  // Filipino (Philippines)
  'likod', 'sa likod', 'pangunahin', 'pangunahing',

  // Android-specific additions
  // Afrikaans (South Africa)
  'agter', 'agterkant', 'hoof', 'primêr',

  // Albanian (Albania)
  'prapa', 'mbrapa', 'kryesore', 'parësore',

  // Amharic (Ethiopia)
  'ከኋላ', 'የኋላ', 'ዋና', 'ቀዳሚ',

  // Armenian (Armenia)
  'հետին', 'հետևում', 'հիմնական', 'առաջնային',

  // Azerbaijani (Azerbaijan)
  'arxa', 'arxada', 'əsas', 'əsas',

  // Bangla/Bengali (Bangladesh, India)
  'পিছনে', 'পেছনে', 'মূল', 'প্রধান',

  // Belarusian (Belarus)
  'задняя', 'ззаду', 'асноўная', 'галоўная',

  // Bosnian (Bosnia)
  'zadnja', 'pozadi', 'glavna', 'primarna',

  // Burmese (Myanmar)
  'နောက်', 'နောက်ဘက်', 'အဓိက', 'ပင်မ',

  // Georgian (Georgia)
  'უკანა', 'უკან', 'მთავარი', 'ძირითადი',

  // Gujarati (India)
  'પાછળ', 'પાછળનું', 'મુખ્ય', 'પ્રાથમિક',

  // Kannada (India)
  'ಹಿಂದೆ', 'ಹಿಂಭಾಗ', 'ಮುಖ್ಯ', 'ಪ್ರಾಥಮಿಕ',

  // Kazakh (Kazakhstan)
  'артқы', 'арта', 'негізгі', 'басты',

  // Khmer (Cambodia)
  'ខាងក្រោយ', 'ក្រោយ', 'សំខាន់', 'ចម្បង',

  // Kyrgyz (Kyrgyzstan)
  'арткы', 'артка', 'негизги', 'башкы',

  // Lao (Laos)
  'ດ້ານຫລັງ', 'ຫລັງ', 'ຫຼັກ', 'ຕົ້ນຕໍ',

  // Macedonian (North Macedonia)
  'задна', 'позади', 'главна', 'примарна',

  // Malayalam (India)
  'പിന്നിൽ', 'പിന്നാമ്പുറം', 'പ്രധാന', 'മുഖ്യ',

  // Marathi (India)
  'मागे', 'मागील', 'मुख्य', 'प्राथमिक',

  // Mongolian (Mongolia)
  'ар', 'арын', 'үндсэн', 'гол',

  // Nepali (Nepal)
  'पछाडि', 'पछिल्लो', 'मुख्य', 'प्राथमिक',

  // Odia (India)
  'ପଛରେ', 'ପଛ', 'ମୁଖ୍ୟ', 'ପ୍ରାଥମିକ',

  // Pashto (Afghanistan)
  'شاته', 'د شا', 'اصلي', 'لومړني',

  // Persian/Farsi (Iran)
  'عقب', 'پشت', 'اصلی', 'اولیه',

  // Punjabi (India)
  'ਪਿੱਛੇ', 'ਪਿਛਲਾ', 'ਮੁੱਖ', 'ਪ੍ਰਾਇਮਰੀ',

  // Sinhala (Sri Lanka)
  'පිටුපස', 'පිටුපස', 'ප්‍රධාන', 'මූලික',

  // Swahili (Kenya, Tanzania)
  'nyuma', 'nyuma ya', 'kuu', 'ya kwanza',

  // Tamil (India, Sri Lanka)
  'பின்', 'பின்புறம்', 'முக்கிய', 'முதன்மை',

  // Telugu (India)
  'వెనుక', 'వెనుకవైపు', 'ప్రధాన', 'ప్రాథమిక',

  // Urdu (Pakistan, India)
  'پیچھے', 'پیچھے کا', 'اصل', 'بنیادی',

  // Uzbek (Uzbekistan)
  'orqa', 'orqada', 'asosiy', 'birlamchi',

  // Zulu (South Africa)
  'ngemuva', 'ngemuva kwe', 'oyinhloko', 'oyintandokazi',

  // Missing high-priority languages from top 50 smartphone usage
  // Hausa (West Africa - Nigeria, Niger, Ghana)
  'baya', 'a baya', 'babba', 'na farko',

  // Javanese (Indonesia)
  'mburi', 'ing mburi', 'utama', 'pokok',

  // Igbo (Nigeria)
  'azụ', 'n\'azụ', 'isi', 'nke mbụ',

  // Bhojpuri (India, Nepal)
  'पाछे', 'पिछला', 'मुख्य', 'प्राथमिक', // Pāche, Pichlā, Mukhya, Prāthamik

  // Oromo (Ethiopia)
  'duubaa', 'duuba', 'guddaa', 'jalqabaa',

  // Cebuano (Philippines)
  'luyo', 'sa luyo', 'panguna', 'mayor',

  // Fula/Fulani (West Africa)
  'ɓooydi', 'e ɓooydi', 'mawɗo', 'aranɗe',

  // Yoruba (Nigeria)
  'ẹhin', 'ni ẹhin', 'akọkọ', 'pataki'
]

/**
 * Indicators to exclude from back camera detection
 */
export const EXCLUDE_INDICATORS: string[] = [
  // English (universal baseline)
  'wide', 'ultra', 'tele', 'dual', 'triple', 'super', 'macro', 'front', 'depth', 'penta', 'quad', 'peri', 'zoom', 'portrait', 'mono', 'pro', 'plus', 'lite',

  // Chinese (Simplified) - Updated with matching terms
  '广角', '超广角', '远摄', '双', '三重', '超级', '微距', '前置', '深度', '五摄', '四摄', '潜望', '变焦', '人像', '单色', '专业', '增强版', '轻量版',
  '长焦', '双镜头', '超广角相机', '双广角镜头', '三镜头',

  // Chinese (Traditional) - Taiwan, Hong Kong
  '廣角', '超廣角', '遠攝', '雙', '三重', '超級', '微距', '前置', '深度', '五攝', '四攝', '潛望', '變焦', '人像', '單色', '專業', '增強版', '輕量版',
  '長焦', '雙鏡頭', '超廣角相機', '雙廣角鏡頭', '三鏡頭',

  // Italian (Italy)
  'grandangolo', 'ultra', 'teleobiettivo', 'doppio', 'triplo', 'super', 'macro', 'frontale', 'profondità', 'penta', 'quadruplo', 'peri', 'zoom', 'ritratto', 'mono', 'pro', 'plus', 'lite',

  // German (Deutsch)
  'weitwinkel', 'ultra', 'tele', 'dual', 'dreifach', 'super', 'makro', 'front', 'tiefe', 'penta', 'quad', 'peri', 'zoom', 'porträt', 'mono', 'pro', 'plus', 'lite',

  // Spanish (Argentina, Mexico, Spain)
  'gran angular', 'ultra', 'teleobjetivo', 'doble', 'triple', 'súper', 'macro', 'frontal', 'profundidad', 'penta', 'cuádruple', 'peri', 'zoom', 'retrato', 'mono', 'pro', 'plus', 'lite',

  // Hindi (India)
  'वाइड', 'अल्ट्रा', 'टेली', 'डुअल', 'ट्रिपल', 'सुपर', 'मैक्रो', 'फ्रंट', 'गहराई', 'पेंटा', 'क्वाड', 'पेरि', 'ज़ूम', 'पोर्ट्रेट', 'मोनो', 'प्रो', 'प्लस', 'लाइट',

  // Polish (Polski) - Updated with provided terms
  'szerokokątny', 'ultraszerokokątny', 'długoogniskowy', 'podwójny', 'trójobiektywowy', 'super', 'makro', 'przedni', 'głębia', 'penta', 'dwuobiektywowy', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Portuguese (Brazil, Portugal)
  'grande angular', 'ultra', 'telefoto', 'duplo', 'triplo', 'super', 'macro', 'frontal', 'profundidade', 'penta', 'quádruplo', 'peri', 'zoom', 'retrato', 'mono', 'pro', 'plus', 'lite',

  // Thai (Thailand)
  'มุมกว้าง', 'อัลตร้า', 'เทเล', 'คู่', 'สามเท่า', 'ซุปเปอร์', 'มาโคร', 'ด้านหน้า', 'ความลึก', 'ห้า', 'สี่', 'ปริ', 'ซูม', 'ภาพบุคคล', 'โมโน', 'โปร', 'พลัส', 'ไลท์',

  // French (France, Canada)
  'grand angle', 'ultra', 'téléobjectif', 'double', 'triple', 'super', 'macro', 'avant', 'profondeur', 'penta', 'quadruple', 'péri', 'zoom', 'portrait', 'mono', 'pro', 'plus', 'lite',

  // Japanese (Japan)
  '広角', 'ウルトラ', 'テレ', 'デュアル', 'トリプル', 'スーパー', 'マクロ', 'フロント', '深度', 'ペンタ', 'クアッド', 'ペリ', 'ズーム', 'ポートレート', 'モノ', 'プロ', 'プラス', 'ライト',

  // Korean (South Korea)
  '광각', '울트라', '망원', '듀얼', '트리플', '슈퍼', '매크로', '전면', '심도', '펜타', '쿼드', '페리', '줌', '인물', '모노', '프로', '플러스', '라이트',

  // Russian (Russia)
  'широкий угол', 'ультра', 'теле', 'двойной', 'тройной', 'супер', 'макро', 'передняя', 'глубина', 'пента', 'четыре', 'пери', 'зум', 'портрет', 'моно', 'про', 'плюс', 'лайт',

  // Dutch (Netherlands, Belgium)
  'groothoek', 'ultra', 'tele', 'dubbel', 'drievoudig', 'super', 'macro', 'voor', 'diepte', 'penta', 'quad', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Swedish (Sweden)
  'vidvinkel', 'ultra', 'tele', 'dubbel', 'trippel', 'super', 'makro', 'fram', 'djup', 'penta', 'quad', 'peri', 'zoom', 'porträtt', 'mono', 'pro', 'plus', 'lite',

  // Norwegian (Norway)
  'vidvinkel', 'ultra', 'tele', 'dobbel', 'trippel', 'super', 'makro', 'front', 'dybde', 'penta', 'quad', 'peri', 'zoom', 'portrett', 'mono', 'pro', 'pluss', 'lite',

  // Danish (Denmark)
  'vidvinkel', 'ultra', 'tele', 'dobbelt', 'tredobbelt', 'super', 'makro', 'front', 'dybde', 'penta', 'quad', 'peri', 'zoom', 'portræt', 'mono', 'pro', 'plus', 'lite',

  // Finnish (Finland)
  'laajakulma', 'ultra', 'tele', 'kaksois', 'kolmois', 'super', 'makro', 'etu', 'syvyys', 'penta', 'nelikko', 'peri', 'zoom', 'muotokuva', 'mono', 'pro', 'plus', 'lite',

  // Turkish (Turkey)
  'geniş açı', 'ultra', 'tele', 'çift', 'üçlü', 'süper', 'makro', 'ön', 'derinlik', 'penta', 'dörtlü', 'peri', 'zoom', 'portre', 'mono', 'pro', 'artı', 'lite',

  // Arabic (Saudi Arabia, UAE)
  'زاوية واسعة', 'ألترا', 'تيلي', 'مزدوج', 'ثلاثي', 'سوبر', 'ماكرو', 'أمامي', 'عمق', 'خماسي', 'رباعي', 'بيري', 'زوم', 'بورتريه', 'أحادي', 'برو', 'بلس', 'لايت',

  // Hebrew (Israel)
  'זווית רחבה', 'אולטרה', 'טלה', 'כפול', 'משולש', 'סופר', 'מאקרו', 'קדמי', 'עומק', 'פנטה', 'רביעי', 'פרי', 'זום', 'פורטרט', 'מונו', 'פרו', 'פלוס', 'לייט',

  // Czech (Czech Republic)
  'širokoúhlý', 'ultra', 'tele', 'dvojitý', 'trojitý', 'super', 'makro', 'přední', 'hloubka', 'penta', 'čtyři', 'peri', 'zoom', 'portrét', 'mono', 'pro', 'plus', 'lite',

  // Slovak (Slovakia)
  'širokoúhlý', 'ultra', 'tele', 'dvojitý', 'trojitý', 'super', 'makro', 'predný', 'hĺbka', 'penta', 'štyri', 'peri', 'zoom', 'portrét', 'mono', 'pro', 'plus', 'lite',

  // Hungarian (Hungary)
  'széles látószög', 'ultra', 'tele', 'dupla', 'hármas', 'szuper', 'makró', 'elülső', 'mélység', 'penta', 'négyes', 'peri', 'zoom', 'portré', 'mono', 'pro', 'plusz', 'lite',

  // Greek (Greece)
  'ευρυγώνιος', 'άλτρα', 'τήλε', 'διπλός', 'τριπλός', 'σούπερ', 'μάκρο', 'μπροστινός', 'βάθος', 'πέντα', 'τετραπλός', 'περί', 'ζουμ', 'πορτρέτο', 'μονό', 'προ', 'πλας', 'λάιτ',

  // Romanian (Romania)
  'unghi larg', 'ultra', 'tele', 'dublu', 'triplu', 'super', 'macro', 'față', 'adâncime', 'penta', 'cvadruplu', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Bulgarian (Bulgaria)
  'широк ъгъл', 'ултра', 'теле', 'двоен', 'троен', 'супер', 'макро', 'преден', 'дълбочина', 'пента', 'четвъртак', 'пери', 'зуум', 'портрет', 'моно', 'про', 'плюс', 'лайт',

  // Croatian (Croatia)
  'široki kut', 'ultra', 'tele', 'dvostruki', 'trostruki', 'super', 'makro', 'prednji', 'dubina', 'penta', 'četverostruki', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Serbian (Serbia)
  'široki ugao', 'ultra', 'tele', 'dvostruki', 'trostruki', 'super', 'makro', 'prednji', 'dubina', 'penta', 'četvorostruki', 'peri', 'zum', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Ukrainian (Ukraine)
  'широкий кут', 'ультра', 'теле', 'подвійний', 'потрійний', 'супер', 'макро', 'передній', 'глибина', 'пента', 'четверний', 'пері', 'зум', 'портрет', 'моно', 'про', 'плюс', 'лайт',

  // Slovenian (Slovenia)
  'širok kot', 'ultra', 'tele', 'dvojni', 'trojni', 'super', 'makro', 'sprednji', 'globina', 'penta', 'četverni', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Lithuanian (Lithuania)
  'platus kampas', 'ultra', 'tele', 'dvigubas', 'trigubas', 'super', 'makro', 'priekinis', 'gylis', 'penta', 'keturgubas', 'peri', 'priartinimas', 'portretas', 'mono', 'pro', 'plius', 'lite',

  // Latvian (Latvia)
  'plašs leņķis', 'ultra', 'tele', 'dubults', 'trīskāršs', 'super', 'makro', 'priekšējais', 'dziļums', 'penta', 'četrkāršs', 'peri', 'tuvināšana', 'portrets', 'mono', 'pro', 'plus', 'lite',

  // Estonian (Estonia)
  'lainurk', 'ultra', 'tele', 'topelt', 'kolmik', 'super', 'makro', 'esi', 'sügavus', 'penta', 'neljas', 'peri', 'suum', 'portree', 'mono', 'pro', 'pluss', 'lite',

  // Icelandic (Iceland)
  'víðsjónarhorn', 'ultra', 'fjarlægð', 'tvöfaldur', 'þrefaldur', 'ofur', 'þysjari', 'fremri', 'dýpt', 'penta', 'fjórfaldur', 'peri', 'aðdráttur', 'andlitsmynd', 'einlit', 'atvinnumaður', 'plús', 'létt',

  // Catalan (Spain)
  'gran angular', 'ultra', 'teleobjectiu', 'doble', 'triple', 'súper', 'macro', 'frontal', 'profunditat', 'penta', 'quàdruple', 'peri', 'zoom', 'retrat', 'mono', 'pro', 'plus', 'lite',

  // Basque (Spain)
  'angelu zabal', 'ultra', 'tele', 'bikoitz', 'hirukoitz', 'super', 'makro', 'aurrekoa', 'sakonera', 'penta', 'laukoitz', 'peri', 'zoom', 'erretratu', 'mono', 'pro', 'plus', 'lite',

  // Galician (Spain)
  'gran angular', 'ultra', 'teleobxectivo', 'dobre', 'triple', 'súper', 'macro', 'frontal', 'profundidade', 'penta', 'cuádruple', 'peri', 'zoom', 'retrato', 'mono', 'pro', 'plus', 'lite',

  // Welsh (UK)
  'ongl lydan', 'ultra', 'tele', 'dwbl', 'triphlyg', 'super', 'macro', 'blaen', 'dyfnder', 'penta', 'pedwarplyg', 'peri', 'chwyddo', 'portread', 'mono', 'pro', 'plws', 'lite',

  // Irish (Ireland)
  'uilleann leathan', 'ultra', 'tele', 'dúbailte', 'triarach', 'super', 'macro', 'tosaigh', 'doimhneacht', 'penta', 'ceathaireach', 'peri', 'súmáil', 'portráid', 'mono', 'pro', 'móide', 'éadrom',

  // Scottish Gaelic (UK)
  'ceàrn farsaing', 'ultra', 'tele', 'dùbailte', 'trì-fillte', 'super', 'macro', 'aghaidh', 'doimhneachd', 'penta', 'ceithir-fillte', 'peri', 'meudachadh', 'dealbh', 'mono', 'pro', 'plus', 'aotrom',

  // Maltese (Malta)
  'angolu wiesa', 'ultra', 'tele', 'doppju', 'triplu', 'super', 'macro', 'ta\' quddiem', 'fond', 'penta', 'kwadruplu', 'peri', 'zoom', 'ritratt', 'mono', 'pro', 'plus', 'lite',

  // Vietnamese (Vietnam)
  'góc rộng', 'siêu', 'kép', 'trước', 'độ sâu', 'năm', 'bốn', 'chân dung', 'đơn sắc', 'chuyên nghiệp', 'cộng', 'nhẹ', 'cực rộng',

  // Indonesian (Indonesia)
  'sudut lebar', 'ultra', 'tele', 'ganda', 'tiga', 'super', 'makro', 'depan', 'kedalaman', 'penta', 'empat', 'peri', 'zoom', 'potret', 'mono', 'pro', 'plus', 'lite',

  // Malay (Malaysia)
  'sudut lebar', 'ultra', 'tele', 'berganda', 'tiga', 'super', 'makro', 'hadapan', 'kedalaman', 'penta', 'empat', 'peri', 'zum', 'potret', 'mono', 'pro', 'tambah', 'ringan',

  // Filipino (Philippines)
  'malawakang anggulo', 'ultra', 'tele', 'dalawa', 'tatlo', 'super', 'makro', 'harap', 'lalim', 'penta', 'apat', 'peri', 'zoom', 'larawan', 'mono', 'pro', 'dagdag', 'magaan',

  // Android-specific additions
  // Afrikaans (South Africa)
  'wydhoek', 'ultra', 'tele', 'dubbel', 'drievoudig', 'super', 'makro', 'voor', 'diepte', 'penta', 'vier', 'peri', 'zoem', 'portret', 'mono', 'pro', 'plus', 'ligter',

  // Albanian (Albania)
  'kënd i gjerë', 'ultra', 'tele', 'dyshe', 'trefishe', 'super', 'makro', 'përpara', 'thellësi', 'penta', 'katër', 'peri', 'zoom', 'portret', 'mono', 'pro', 'plus', 'e lehtë',

  // Amharic (Ethiopia)
  'ሰፊ አንግል', 'ኡልትራ', 'ቴሌ', 'ድርብ', 'ሶስት', 'ሱፐር', 'ማክሮ', 'ፊት', 'ጥልቀት', 'ፔንታ', 'አራት', 'ፔሪ', 'ዙም', 'ፖርትሬት', 'ሞኖ', 'ፕሮ', 'ፕላስ', 'ቀላል',

  // Armenian (Armenia)
  'լայն անկյուն', 'ուլտրա', 'տելե', 'կրկնակի', 'եռակի', 'սուպեր', 'մակրո', 'առջևում', 'խորություն', 'պենտա', 'չորս', 'պերի', 'մոտեցում', 'դիմանկար', 'մոնո', 'պրո', 'պլյուս', 'թեթև',

  // Azerbaijani (Azerbaijan)
  'geniş bucaq', 'ultra', 'tele', 'ikili', 'üçlü', 'super', 'makro', 'ön', 'dərinlik', 'penta', 'dörd', 'peri', 'böyütmə', 'portret', 'mono', 'pro', 'plus', 'yüngül',

  // Bangla/Bengali (Bangladesh, India)
  'প্রশস্ত কোণ', 'আল্ট্রা', 'টেলি', 'দ্বিগুণ', 'তিনগুণ', 'সুপার', 'ম্যাক্রো', 'সামনে', 'গভীরতা', 'পেন্টা', 'চার', 'পেরি', 'জুম', 'প্রতিকৃতি', 'মনো', 'প্রো', 'প্লাস', 'হালকা',

  // Belarusian (Belarus)
  'шырокі кут', 'ультра', 'тэле', 'падвойны', 'тройны', 'супер', 'макра', 'пярэдні', 'глыбіня', 'пента', 'чатыры', 'пэры', 'маштабаванне', 'партрэт', 'мона', 'пра', 'плюс', 'лёгкі',

  // Bosnian (Bosnia)
  'široki ugao', 'ultra', 'tele', 'dvostruki', 'trostruki', 'super', 'makro', 'prednji', 'dubina', 'penta', 'četvorostruki', 'peri', 'zum', 'portret', 'mono', 'pro', 'plus', 'lite',

  // Burmese (Myanmar)
  'ကျယ်ကျယ်ထောင့်', 'အလ်ထရာ', 'တယ်လီ', 'နှစ်ဆ', 'သုံးဆ', 'စူပါ', 'မက်ခရို', 'ရှေ့', 'အနက်', 'ပင်တာ', 'လေး', 'ပယ်ရီ', 'ဇူးမ်', 'ပုံတူ', 'မိုနို', 'ပရို', 'ပလပ်စ်', 'ပေါ့',

  // Georgian (Georgia)
  'ფართო კუთხე', 'ულტრა', 'ტელე', 'ორმაგი', 'სამმაგი', 'სუპერ', 'მაკრო', 'წინ', 'სიღრმე', 'პენტა', 'ოთხი', 'პერი', 'ზუმი', 'პორტრეტი', 'მონო', 'პრო', 'პლუს', 'მსუბუქი',

  // Gujarati (India)
  'પહોળો કોણ', 'અલ્ટ્રા', 'ટેલી', 'બે', 'ત્રણ', 'સુપર', 'મેક્રો', 'આગળ', 'ઊંડાઈ', 'પેન્ટા', 'ચાર', 'પેરી', 'ઝૂમ', 'પોર્ટ્રેટ', 'મોનો', 'પ્રો', 'પ્લસ', 'હલકું',

  // Kannada (India)
  'ವಿಶಾಲ ಕೋನ', 'ಅಲ್ಟ್ರಾ', 'ಟೆಲಿ', 'ಎರಡು', 'ಮೂರು', 'ಸುಪರ್', 'ಮ್ಯಾಕ್ರೋ', 'ಮುಂದೆ', 'ಆಳ', 'ಪೆಂಟಾ', 'ನಾಲ್ಕು', 'ಪೆರಿ', 'ಜೂಮ್', 'ಭಾವಚಿತ್ರ', 'ಮೊನೊ', 'ಪ್ರೊ', 'ಪ್ಲಸ್', 'ಲೈಟ್',

  // Kazakh (Kazakhstan)
  'кең бұрыш', 'ультра', 'теле', 'қос', 'үш', 'супер', 'макро', 'алдыңғы', 'тереңдік', 'пента', 'төрт', 'пери', 'зум', 'портрет', 'моно', 'про', 'плюс', 'жеңіл',

  // Khmer (Cambodia)
  'មុំទូលាយ', 'អ៊ុលត្រា', 'តេលេ', 'ពីរ', 'បី', 'ស៊ុបប័រ', 'ម៉ាក្រូ', 'ខាងមុខ', 'ជម្រៅ', 'ប៉ែនតា', 'បួន', 'ប៉េរី', 'ហ្សូម', 'រូបភាព', 'ម៉ូណូ', 'ប្រូ', 'ប្លាស់', 'ស្រាល',

  // Kyrgyz (Kyrgyzstan)
  'кенең бурч', 'ультра', 'теле', 'эки', 'үч', 'супер', 'макро', 'алдыңкы', 'тереңдик', 'пента', 'төрт', 'пери', 'зум', 'портрет', 'моно', 'про', 'плюс', 'жеңил',

  // Lao (Laos)
  'ມູມກວ້າງ', 'ອຸນຕຣາ', 'ເທເລ', 'ຄູ່', 'ສາມ', 'ຊູເປີ', 'ແມັກໂຄຣ', 'ໜ້າ', 'ຄວາມເລິກ', 'ເປັນຕາ', 'ສີ່', 'ເປຣີ', 'ຊູມ', 'ຮູບ', 'ໂມໂນ', 'ໂປຣ', 'ພລັສ', 'ເບົາ',

  // Macedonian (North Macedonia)
  'широк агол', 'ултра', 'теле', 'двоен', 'троен', 'супер', 'макро', 'преден', 'длабочина', 'пента', 'четири', 'пери', 'зум', 'портрет', 'моно', 'про', 'плус', 'лесен',

  // Malayalam (India)
  'വിശാല കോൺ', 'അൾട്രാ', 'ടെലി', 'ഇരട്ട', 'മൂന്ന്', 'സൂപ്പർ', 'മാക്രോ', 'മുന്നിൽ', 'ആഴം', 'പെന്റാ', 'നാല്', 'പെരി', 'സൂം', 'പോർട്രെയ്റ്റ്', 'മോണോ', 'പ്രോ', 'പ്ലസ്', 'ലൈറ്റ്',

  // Marathi (India)
  'रुंद कोन', 'अल्ट्रा', 'टेली', 'दुहेरी', 'तिहेरी', 'सुपर', 'मॅक्रो', 'समोर', 'खोली', 'पेंटा', 'चार', 'पेरी', 'झूम', 'पोर्ट्रेट', 'मोनो', 'प्रो', 'प्लस', 'हलका',

  // Mongolian (Mongolia)
  'өргөн өнцөг', 'ультра', 'теле', 'давхар', 'гурван', 'супер', 'макро', 'өмнө', 'гүн', 'пента', 'дөрөв', 'пери', 'томруулах', 'хөрөг зураг', 'моно', 'про', 'нэмэлт', 'хөнгөн',

  // Nepali (Nepal)
  'फराकिलो कोण', 'अल्ट्रा', 'टेली', 'डबल', 'ट्रिपल', 'सुपर', 'म्याक्रो', 'अगाडि', 'गहिराई', 'पेन्टा', 'चार', 'पेरी', 'जुम', 'पोर्ट्रेट', 'मोनो', 'प्रो', 'प्लस', 'हल्का',

  // Odia (India)
  'ପ୍ରଶସ୍ତ କୋଣ', 'ଅଲ୍ଟ୍ରା', 'ଟେଲି', 'ଡବଲ୍', 'ଟ୍ରିପଲ୍', 'ସୁପର', 'ମ୍ୟାକ୍ରୋ', 'ଆଗ', 'ଗଭୀରତା', 'ପେଣ୍ଟା', 'ଚାରି', 'ପେରି', 'ଜୁମ୍', 'ପର୍ଟ୍ରେଟ୍', 'ମୋନୋ', 'ପ୍ରୋ', 'ପ୍ଲସ୍', 'ହାଲୁକା',

  // Pashto (Afghanistan)
  'پراخه زاویه', 'الټرا', 'ټیلي', 'دوه ګونی', 'درې ګونی', 'سوپر', 'میکرو', 'مخکینۍ', 'ژورتیا', 'پنتا', 'څلور', 'پیري', 'زوم', 'انځور', 'مونو', 'پرو', 'پلس', 'سپک',

  // Persian/Farsi (Iran)
  'زاویه وسیع', 'فوق‌العاده', 'تله', 'دوگانه', 'سه‌گانه', 'فوق', 'ماکرو', 'جلو', 'عمق', 'پنتا', 'چهارگانه', 'پری', 'زوم', 'پرتره', 'تک‌رنگ', 'حرفه‌ای', 'پلاس', 'سبک',

  // Punjabi (India)
  'ਚੌੜਾ ਕੋਣ', 'ਅਲਟਰਾ', 'ਟੈਲੀ', 'ਡਬਲ', 'ਟ੍ਰਿਪਲ', 'ਸੁਪਰ', 'ਮੈਕਰੋ', 'ਅੱਗੇ', 'ਡੂੰਘਾਈ', 'ਪੈਂਟਾ', 'ਚਾਰ', 'ਪੈਰੀ', 'ਜ਼ੂਮ', 'ਪੋਰਟਰੇਟ', 'ਮੋਨੋ', 'ਪ੍ਰੋ', 'ਪਲੱਸ', 'ਹਲਕਾ',

  // Sinhala (Sri Lanka)
  'පුළුල් කෝණය', 'අල්ට්‍රා', 'ටෙලි', 'ද්විත්ව', 'ත්‍රිත්ව', 'සුපර්', 'මැක්‍රෝ', 'ඉදිරිපස', 'ගැඹුර', 'පෙන්ටා', 'හතර', 'පෙරි', 'සූම්', 'ප්‍රතිමුර්ති', 'මොනො', 'ප්‍රෝ', 'ප්ලස්', 'සැහැල්ලු',

  // Swahili (Kenya, Tanzania)
  'pembe pana', 'ultra', 'tele', 'maradufu', 'mara tatu', 'super', 'makro', 'mbele', 'kina', 'penta', 'nne', 'peri', 'kuza', 'picha ya uso', 'mono', 'mtaalamu', 'ziada', 'nyepesi',

  // Tamil (India, Sri Lanka)
  'அகலமான கோணம்', 'அல்ட்ரா', 'டெலி', 'இரட்டை', 'மூன்று', 'சூப்பர்', 'மேக்ரோ', 'முன்', 'ஆழம்', 'பென்டா', 'நான்கு', 'பெரி', 'ஜூம்', 'உருவப்படம்', 'மோனோ', 'ப்ரோ', 'பிளஸ்', 'லைட்',

  // Telugu (India)
  'వెడల్పు కోణం', 'అల్ట్రా', 'టెలీ', 'రెండింతలు', 'మూడింతలు', 'సూపర్', 'మాక్రో', 'ముందు', 'లోతు', 'పెంటా', 'నాలుగు', 'పెరి', 'జూమ్', 'పోర్ట్రెయిట్', 'మోనో', 'ప్రో', 'ప్లస్', 'లైట్',

  // Urdu (Pakistan, India)
  'چوڑا زاویہ', 'الٹرا', 'ٹیلی', 'ڈبل', 'ٹرپل', 'سپر', 'میکرو', 'آگے', 'گہرائی', 'پینٹا', 'چار', 'پیری', 'زوم', 'پورٹریٹ', 'مونو', 'پرو', 'پلس', 'ہلکا',

  // Uzbek (Uzbekistan)
  'keng burchak', 'ultra', 'tele', 'ikki marta', 'uch marta', 'super', 'makro', 'old', 'chuqurlik', 'penta', 'to\'rt', 'peri', 'kattalashtirish', 'portret', 'mono', 'pro', 'ortiq', 'engil',

  // Zulu (South Africa)
  'i-angle ebanzi', 'i-ultra', 'i-tele', 'kabili', 'kathathu', 'i-super', 'i-macro', 'phambili', 'ukujula', 'i-penta', 'kane', 'i-peri', 'i-zoom', 'isithombe', 'i-mono', 'i-pro', 'i-plus', 'lula',

  // Missing high-priority languages from top 50 smartphone usage
  // Hausa (West Africa - Nigeria, Niger, Ghana)
  'fadi', 'ultra', 'tele', 'biyu', 'uku', 'super', 'macro', 'gaba', 'zurfi', 'biyar', 'hudu', 'peri', 'zoom', 'hoto', 'mono', 'gwani', 'kari', 'sauki',

  // Javanese (Indonesia)
  'amba', 'ultra', 'tele', 'loro', 'telu', 'super', 'macro', 'ngarep', 'jero', 'lima', 'papat', 'peri', 'zoom', 'potret', 'mono', 'pro', 'tambah', 'entheng',

  // Igbo (Nigeria)
  'sara sara', 'ultra', 'tele', 'abụọ', 'atọ', 'super', 'macro', 'ihu', 'omimi', 'ise', 'anọ', 'peri', 'zoom', 'foto', 'mono', 'pro', 'mgbakwunye', 'dị mfe',

  // Bhojpuri (India, Nepal)
  'चौड़ा कोण', 'अल्ट्रा', 'टेली', 'दुगुना', 'तिगुना', 'सुपर', 'मैक्रो', 'आगे', 'गहराई', 'पांच', 'चार', 'पेरी', 'जूम', 'तस्वीर', 'मोनो', 'प्रो', 'प्लस', 'हल्का',

  // Oromo (Ethiopia)
  'bal\'aa bal\'aa', 'ultra', 'tele', 'lama', 'sadii', 'super', 'macro', 'fuuldura', 'gadi', 'shan', 'afur', 'peri', 'zoom', 'suuraa', 'mono', 'pro', 'dabalataa', 'salphaa',

  // Cebuano (Philippines)
  'lapad nga anggulo', 'ultra', 'tele', 'doble', 'tulo', 'super', 'macro', 'atubangan', 'kalawom', 'lima', 'upat', 'peri', 'zoom', 'litrato', 'mono', 'pro', 'dugang', 'gaan',

  // Fula/Fulani (West Africa)
  'hendu mawndu', 'ultra', 'tele', 'ɗiɗi', 'tati', 'super', 'macro', 'ɓooydi', 'juulde', 'jowi', 'nayi', 'peri', 'zoom', 'natal', 'mono', 'pro', 'ɓeydu', 'feeɲu',

  // Yoruba (Nigeria)
  'igun gbooro', 'ultra', 'tele', 'meji', 'meta', 'super', 'macro', 'iwaju', 'ijinle', 'marun', 'merin', 'peri', 'zoom', 'aworan', 'mono', 'pro', 'afikun', 'fẹẹrẹ'
];
export const LANGUAGE_CONFIG = {
  'en': {
      'cameraAccessNeeded': 'Camera access needed',
      'allowCameraAccess': 'Allow access to the camera to scan the product',
      'enableCamera': 'Enable Camera',
      'locationAccessNeeded': 'Location access needed',
      'locationPurpose': 'To help identify & report fake products. \n Don\'t worry, this data is safe & anonymized.',
      'enableLocation': 'Enable Location',
      'keepProductCentered': 'Bring product into view and align the logo',
      'productIdentified': 'Product identified',
      'verificationInProgress': 'Verification in progress. Please hold the phone still.',
      'productGenuine': 'This product is genuine',
      'cannotConfirm': 'Try Again',
      'unableToAuthenticate': 'Unable to authenticate product',
      'productNotInFocus': 'Product not in focus. Please try again',
      'chooseLabel': 'Choose the label type',
      'startScanning': 'Start Scanning',
      'scanAgain': 'Scan Again',
      'clearFocus': 'Clear focus & fit = fast verification',
      'clearFocusDetail': 'Place the product in a well-lit environment & make sure there are no other items in focus',
      'fastInternet': 'Fast internet = fast verification',
      'fastInternetDetail': 'Use a reliable internet connection for optimal results. Slower speeds may delay verification',
      'genuine': 'Genuine',
      'newVersionAvailable': 'New Version Available',
      'updateDescription': 'Update for more accurate results and a smoother app experience',
      'updateNow': 'Update Now',
      'later': 'Later',
      'understoodStartScanning': 'Understood, Start Scanning',
      'poorInternetTitle': 'Poor Internet Connection',
      'poorInternetDescription': 'To verify the product reliably, please switch to a better internet connection.',
      'establishingConnection_1': 'Establishing connection',
      'establishingConnection_2': 'Hang in there, almost connected',
      'establishingConnection_3': 'Almost there',
      'tryAgain': 'Try Again'
  },
  'zh': {
      'cameraAccessNeeded': '需要相机访问权限',
      'allowCameraAccess': '允许访问相机以扫描产品',
      'enableCamera': '启用相机',
      'locationAccessNeeded': '需要位置访问权限',
      'locationPurpose': '帮助识别和举报假冒产品。\n 请放心，这些数据是安全且匿名的。',
      'enableLocation': '启用位置',
      'keepProductCentered': '将产品置于视野中并对齐标志',
      'productIdentified': '产品已识别',
      'verificationInProgress': '验证进行中。请保持手机静止。',
      'productGenuine': '此产品是正品',
      'cannotConfirm': '重试',
      'unableToAuthenticate': '无法验证产品',
      'productNotInFocus': '产品未对焦。请重试',
      'chooseLabel': '选择标签类型',
      'startScanning': '开始扫描',
      'scanAgain': '再次扫描',
      'clearFocus': '清晰对焦与适合 = 快速验证',
      'clearFocusDetail': '将产品放在光线充足的环境中，并确保没有其他物品在焦点范围内',
      'fastInternet': '快速网络 = 快速验证',
      'fastInternetDetail': '使用可靠的网络连接以获得最佳结果。较慢的速度可能会延迟验证',
      'genuine': '正品',
      'newVersionAvailable': '新版本可用',
      'updateDescription': '更新以获得更准确的结果和更流畅的应用体验',
      'updateNow': '立即更新',
      'later': '稍后',
      'understoodStartScanning': '明白，开始扫描',
      'poorInternetTitle': '网络连接不佳',
      'poorInternetDescription': '为了可靠地验证产品，请切换到更好的网络连接。',
      'establishingConnection_1': '正在建立连接',
      'establishingConnection_2': '请稍候，即将连接',
      'establishingConnection_3': '即将完成',
       'tryAgain': '重试'
  },
  'de': {
      'cameraAccessNeeded': 'Kamerazugriff erforderlich',
      'allowCameraAccess': 'Erlauben Sie den Zugriff auf die Kamera, um das Produkt zu scannen',
      'enableCamera': 'Kamera aktivieren',
      'locationAccessNeeded': 'Standortzugriff erforderlich',
      'locationPurpose': 'Zur Identifizierung und Meldung gefälschter Produkte. \n Keine Sorge, diese Daten sind sicher und anonymisiert.',
      'enableLocation': 'Standort aktivieren',
      'keepProductCentered': 'Bringen Sie das Produkt ins Blickfeld und führen Sie die Logos zusammen',
      'productIdentified': 'Produkt identifiziert',
      'verificationInProgress': 'Überprüfung läuft. Bitte halten Sie das Telefon ruhig.',
      'productGenuine': 'Dieses Produkt ist original',
      'cannotConfirm': 'Nochmal versuchen',
      'unableToAuthenticate': 'Produkt kann nicht authentifiziert werden',
      'productNotInFocus': 'Produkt nicht im Fokus. Bitte versuchen Sie es erneut',
      'chooseLabel': 'Wählen Sie den Etikettentyp',
      'startScanning': 'Scannen starten',
      'scanAgain': 'Erneut scannen',
      'clearFocus': 'Klarer Fokus & Passform = schnelle Verifizierung',
      'clearFocusDetail': 'Platzieren Sie das Produkt in einer gut beleuchteten Umgebung und stellen Sie sicher, dass keine anderen Objekte im Fokus sind',
      'fastInternet': 'Schnelles Internet = schnelle Verifizierung',
      'fastInternetDetail': 'Verwenden Sie eine zuverlässige Internetverbindung für optimale Ergebnisse. Langsamere Geschwindigkeiten können die Verifizierung verzögern',
      'genuine': 'Original',
      'newVersionAvailable': 'Neue Version verfügbar',
      'updateDescription': 'Aktualisieren Sie für genauere Ergebnisse und eine reibungslosere App-Erfahrung',
      'updateNow': 'Jetzt aktualisieren',
      'later': 'Später',
      'understoodStartScanning': 'Verstanden, Scannen starten',
      'poorInternetTitle': 'Schlechte Internetverbindung',
      'poorInternetDescription': 'Um das Produkt zuverlässig zu verifizieren, wechseln Sie zu einer besseren Verbindung',
      'establishingConnection_1': 'Verbindung wird hergestellt',
      'establishingConnection_2': 'Bitte warten, fast verbunden',
      'establishingConnection_3': 'Fast geschafft',
       'tryAgain': 'Erneut versuchen'
  },
  'es': {
      'cameraAccessNeeded': 'Se necesita acceso a la cámara',
      'allowCameraAccess': 'Permitir acceso a la cámara para escanear el producto',
      'enableCamera': 'Habilitar cámara',
      'locationAccessNeeded': 'Se necesita acceso a la ubicación',
      'locationPurpose': 'Para ayudar a identificar e informar de productos falsos. \n No te preocupes, estos datos son seguros y anónimos.',
      'enableLocation': 'Habilitar ubicación',
      'keepProductCentered': 'Coloque el producto a la vista y alinee los logotipos',
      'productIdentified': 'Producto identificado',
      'verificationInProgress': 'Verificación en progreso. Por favor, no cuelgue el telefono.',
      'productGenuine': 'Este producto es original.',
      'cannotConfirm': 'Intentar de nuevo',
      'unableToAuthenticate': 'No se puede autenticar el producto',
      'productNotInFocus': 'Producto desenfocado. Por favor, inténtelo de nuevo',
      'chooseLabel': 'Elija el tipo de etiqueta',
      'startScanning': 'Comenzar a escanear',
      'scanAgain': 'Escanear de nuevo',
      'clearFocus': 'Con enfoque y ajuste claros = verificación rápida',
      'clearFocusDetail': 'Coloque el producto en un ambiente bien iluminado y asegúrese de que no haya otros objetos enfocados',
      'fastInternet': 'Internet rápido = verificación rápida',
      'fastInternetDetail': 'Utilice una conexión a Internet fiable para obtener resultados óptimos. Las velocidades más lentas pueden retrasar la verificación',
      'genuine': 'Auténtico',
      'newVersionAvailable': 'Nueva versión disponible',
      'updateDescription': 'Actualice para obtener resultados más precisos y una experiencia de aplicación más fluida',
      'updateNow': 'Actualizar ahora',
      'later': 'Más tarde',
      'understoodStartScanning': 'Entendido, Comenzar a escanear',
      'poorInternetTitle': 'Conexión a Internet deficiente',
      'poorInternetDescription': 'Para verificar el producto de manera confiable, cambie a una mejor conexión a Internet',
      'establishingConnection_1': 'Estableciendo conexión',
      'establishingConnection_2': 'Espera, casi conectado',
      'establishingConnection_3': 'Casi listo',
       'tryAgain': 'Intentar de nuevo'
  },
  'fr': {
      'cameraAccessNeeded': 'Accès à la caméra nécessaire',
      'allowCameraAccess': 'Autoriser l\'accès à la caméra pour scanner le produit',
      'enableCamera': 'Activer la caméra',
      'locationAccessNeeded': 'Accès à la localisation nécessaire',
      'locationPurpose': 'Pour aider à identifier et signaler les produits contrefaits. \n Ne vous inquiétez pas, ces données sont sécurisées et anonymisées.',
      'enableLocation': 'Activer la localisation',
      'keepProductCentered': 'Mettez le produit en vue et alignez les logos',
      'productIdentified': 'Produit identifié',
      'verificationInProgress': 'Vérification en cours. Veuillez garder le téléphone immobile.',
      'productGenuine': 'Ce produit est authentique',
      'cannotConfirm': 'Réessayer',
      'unableToAuthenticate': 'Impossible d\'authentifier le produit',
      'productNotInFocus': 'Produit pas au point. Veuillez réessayer',
      'chooseLabel': 'Choisissez le type d\'étiquette',
      'startScanning': 'Commencer la scannérisation',
      'scanAgain': 'Scanner à nouveau',
      'clearFocus': 'Mise au point claire & positionnement correct = vérification rapide',
      'clearFocusDetail': 'Placez le produit dans un environnement bien éclairé et assurez-vous qu\'aucun autre objet est dans le champs de la caméra ',
      'fastInternet': 'Connexion rapide = vérification rapide',
      'fastInternetDetail': 'Utilisez une connexion Internet fiable pour un résultat optimal. Une vitesse plus lente peut retarder la vérification',
      'genuine': 'Authentique',
      'newVersionAvailable': 'Nouvelle version disponible',
      'updateDescription': 'Mettez à jour pour des résultats plus précis et une expérience d\'application plus fluide',
      'updateNow': 'Mettre à jour maintenant',
      'later': 'Plus tard',
      'understoodStartScanning': 'Compris, Commencez la scannérisation',
      'poorInternetTitle': 'Mauvaise connexion Internet',
      'poorInternetDescription': 'Pour vérifier le produit correctement,  passez à une meilleure connexion',
      'establishingConnection_1': 'Etablissez la connection',
      'establishingConnection_2': 'Patientez, presque connecté',
      'establishingConnection_3': 'Presque terminé',
       'tryAgain': 'Réessayern'
  },
  'hi': {
      'cameraAccessNeeded': 'कैमरा एक्सेस की आवश्यकता है',
      'allowCameraAccess': 'उत्पाद को स्कैन करने के लिए कैमरे तक पहुंच की अनुमति दें',
      'enableCamera': 'कैमरा सक्षम करें',
      'locationAccessNeeded': 'स्थान एक्सेस की आवश्यकता है',
      'locationPurpose': 'नकली उत्पादों की पहचान और रिपोर्ट करने में मदद करने के लिए। \n चिंता न करें, यह डेटा सुरक्षित और अनाम है।',
      'enableLocation': 'स्थान सक्षम करें',
      'keepProductCentered': 'उत्पाद को दृश्य में लाएं और लोगो को संरेखित करें',
      'productIdentified': 'उत्पाद पहचाना गया',
      'verificationInProgress': 'सत्यापन प्रगति पर है। कृपया फोन को स्थिर रखें।',
      'productGenuine': 'यह उत्पाद असली है',
      'cannotConfirm': 'फिर से कोशिश करें',
      'unableToAuthenticate': 'उत्पाद को प्रमाणित करने में असमर्थ',
      'productNotInFocus': 'उत्पाद फोकस में नहीं है। कृपया पुन: प्रयास करें',
      'chooseLabel': 'लेबल प्रकार चुनें',
      'startScanning': 'स्कैनिंग शुरू करें',
      'scanAgain': 'फिर से स्कैन करें',
      'clearFocus': 'स्पष्ट फोकस और फिट = त्वरित सत्यापन',
      'clearFocusDetail': 'उत्पाद को अच्छी रोशनी वाले वातावरण में रखें और सुनिश्चित करें कि कोई अन्य वस्तु फोकस में न हो',
      'fastInternet': 'तेज़ इंटरनेट = त्वरित सत्यापन',
      'fastInternetDetail': 'इष्टतम परिणामों के लिए विश्वसनीय इंटरनेट कनेक्शन का उपयोग करें। धीमी गति से सत्यापन में देरी हो सकती है',
      'genuine': 'असली',
      'newVersionAvailable': 'नया संस्करण उपलब्ध है',
      'updateDescription': 'अधिक सटीक परिणामों और बेहतर ऐप अनुभव के लिए अपडेट करें',
      'updateNow': 'अभी अपडेट करें',
      'later': 'बाद में',
      'understoodStartScanning': 'समझा, स्कैनिंग शुरू करें',
      'poorInternetTitle': 'खराब इंटरनेट कनेक्शन',
      'poorInternetDescription': 'उत्पाद को विश्वसनीय रूप से सत्यापित करने के लिए कृपया बेहतर इंटरनेट कनेक्शन पर स्विच करें।,',
      'establishingConnection_1': 'कनेक्शन स्थापित किया जा रहा है',
      'establishingConnection_2': 'रुकिए, लगभग कनेक्ट हो गया',
      'establishingConnection_3': 'लगभग हो गया',
       'tryAgain': 'फिर से प्रयास करें'
  },
  'it': {
      'cameraAccessNeeded': 'Necessario accesso alla fotocamera',
      'allowCameraAccess': 'Consentire l\'accesso alla fotocamera per scansionare il prodotto',
      'enableCamera': 'Abilita fotocamera',
      'locationAccessNeeded': 'Necessario accesso alla posizione',
      'locationPurpose': 'Per aiutare a identificare e segnalare prodotti contraffatti. \n Non preoccuparti, questi dati sono sicuri e anonimi.',
      'enableLocation': 'Abilita posizione',
      'keepProductCentered': 'Inquadra il prodotto e allinea i loghi',
      'productIdentified': 'Prodotto identificato',
      'verificationInProgress': 'Verifica in corso. Si prega di tenere il telefono fermo.',
      'productGenuine': 'Questo prodotto è autentico',
      'cannotConfirm': 'Riprova',
      'unableToAuthenticate': 'Impossibile autenticare il prodotto',
      'productNotInFocus': 'Prodotto non a fuoco. Si prega di riprovare',
      'chooseLabel': 'Scegli il tipo di etichetta',
      'startScanning': 'Inizia scansione',
      'scanAgain': 'Scansiona di nuovo',
      'clearFocus': 'Messa a fuoco chiara e giusta inquadratura = verifica rapida',
      'clearFocusDetail': 'Posiziona il prodotto in un ambiente ben illuminato e assicurati che non ci siano altri oggetti nell\'inquadratura',
      'fastInternet': 'Internet veloce = verifica rapida',
      'fastInternetDetail': 'Utilizza una connessione Internet affidabile per risultati ottimali. Velocità più lente potrebbero ritardare la verifica',
      'genuine': 'Autentico',
      'newVersionAvailable': 'Nuova versione disponibile',
      'updateDescription': 'Aggiorna per risultati più accurati e un\'esperienza app più fluida',
      'updateNow': 'Aggiorna ora',
      'later': 'Più tardi',
      'understoodStartScanning': 'Capito, Inizia scansione',
      'poorInternetTitle': 'Connessione Internet scarsa',
      'poorInternetDescription': 'Per verificare il prodotto in modo affidabile, passa a una connessione Internet migliore',
      'establishingConnection_1': 'Connessione in corso',
      'establishingConnection_2': 'Attendi, quasi connesso',
      'establishingConnection_3': 'Ci siamo quasi',
       'tryAgain': 'Riprova'
  },
  'pl': {
      'cameraAccessNeeded': 'Wymagany dostęp do kamery',
      'allowCameraAccess': 'Zezwól na dostęp do kamery, aby zeskanować produkt',
      'enableCamera': 'Włącz kamerę',
      'locationAccessNeeded': 'Wymagany dostęp do lokalizacji',
      'locationPurpose': 'Aby  pomóc w identyfikacji i zgłaszaniu podrobionych produktów. \n Nie martw się, te dane są bezpieczne i anonimowe.',
      'enableLocation': 'Włącz lokalizację',
      'keepProductCentered': 'Umieść produkt w kadrze i wyrównaj logo',
      'productIdentified': 'Produkt zidentyfikowany',
      'verificationInProgress': 'Weryfikacj a w toku. Proszę trzymać telefon nieruchomo.',
      'productGenuine': 'Ten produkt jest oryginalny',
      'cannotConfirm': 'Spróbuj ponownie',
      'unableToAuthenticate': 'Nie można uwierzytelnić produktu',
      'productNotInFocus': 'Produkt nie jest w centrum uwagi.\nProszę spróbować ponownie',
      'chooseLabel': 'Wybierz typ etykiety',
      'startScanning': 'Rozpocznij skanowanie',
      'scanAgain': 'Skanuj ponownie',
      'clearFocus': 'Wyraźny fokus i dopasowanie = szybka weryfikacja',
      'clearFocusDetail': 'Umieść produkt w dobrze oświetlonym otoczeniu i upewnij się, że żadne inne przedmioty nie są w centrum uwagi',
      'fastInternet': 'Szybki internet = szybka weryfikacja',
      'fastInternetDetail': 'Korzystaj z niezawodnego połączenia internetowego, aby uzyskać optymalne wyniki. Wolniejsze prędkości mogą opóźnić weryfikację',
      'genuine': 'Oryginalny',
      'newVersionAvailable': 'Nowa wersja dostępna',
      'updateDescription': 'Zaktualizuj aby uzyskać dokładniejsze wyniki i płynniejsze działanie aplikacji',
      'updateNow': 'Zaktualizuj teraz',
      'later': 'Później',
      'understoodStartScanning': 'Zrozumiałe, Rozpocznij skanowanie',
      'poorInternetTitle': 'Słabe połączenie internetowe',
      'poorInternetDescription': 'Aby niezawodnie zweryfikować produkt, przełącz się na lepsze połączenie internetowe.',
      'establishingConnection_1': 'Nawiązywanie połączenia',
      'establishingConnection_2': 'Czekaj, prawie połączono',
      'establishingConnection_3': 'Prawie gotowe',
       'tryAgain': 'Spróbuj ponownie'
  },
  'pt': {
      'cameraAccessNeeded': 'Acesso à câmara necessário',
      'allowCameraAccess': 'Permitir acesso à câmara para digitalizar o produto',
      'enableCamera': 'Ativar a câmara',
      'locationAccessNeeded': 'Acesso à localização necessário',
      'locationPurpose': 'Para ajudar a identificar e reportar produtos falsificados. \n Não se preocupe, estes dados são seguros e anónimos.\n',
      'enableLocation': 'Ativar a localização',
      'keepProductCentered': 'Coloque o produto em destaque e alinhe os logótipos',
      'productIdentified': 'Produto identificado',
      'verificationInProgress': 'Verificação em progresso. Por favor, mantenha o telefone imóvel.',
      'productGenuine': 'Este produto é original',
      'cannotConfirm': 'Tentar novamente',
      'unableToAuthenticate': 'Não foi possível autenticar o produto',
      'productNotInFocus': 'Produto fora de foco. Por favor, tente novamente',
      'chooseLabel': 'Escolha o tipo de rótulo',
      'startScanning': 'Iniciar digitalização',
      'scanAgain': 'Digitalizar novamente',
      'clearFocus': 'Foco claro e ajuste correto = verificação rápida',
      'clearFocusDetail': 'Coloque o produto num ambiente bem iluminado e certifique-se de que não há outros itens em foco.',
      'fastInternet': 'Internet rápida = verificação rápida',
      'fastInternetDetail': 'Utilize uma ligação à internet fiável para obter melhores resultados. Velocidades mais lentas podem atrasar a verificação.',
      'genuine': 'Original',
      'newVersionAvailable': 'Nova versão disponível',
      'updateDescription': 'Atualize para obter resultados mais precisos e uma experiência de aplicação mais fluida.',
      'updateNow': 'Atualizar agora',
      'later': 'Mais tarde',
      'understoodStartScanning': 'Entendido, Iniciar digitalização',
      'poorInternetTitle': 'Ligação fraca',
      'poorInternetDescription': 'Para verificar o produto de forma confiável, altere a sua internet para uma com melhor conexão',
      'establishingConnection_1': 'A estabelecer ligação',
      'establishingConnection_2': 'Aguarde, quase conectado',
      'establishingConnection_3': 'Quase lá',
       'tryAgain': 'Tentar novamente'
  },
  'th': {
      'cameraAccessNeeded': 'ต้องการเข้าถึงกล้อง',
      'allowCameraAccess': 'อนุญาติให้เข้าถึงกล้องเพื่อสแกนผลิตภัณฑ์',
      'enableCamera': 'เปิดใช้งานกล้อง',
      'locationAccessNeeded': 'ต้องการการเข้าถึงตําแหน่งที่ตั้ง',
      'locationPurpose': 'เพื่อช่วยระบุและรายงานผลิตภัณฑ์ปลอม อย่ากังวลข้อมูลนี้ปลอดภัย และไม่ระบุตัวตน',
      'enableLocation': 'เปิดใช้งาน ตําแหน่งที่ตั้ง',
      'keepProductCentered': 'นำผลิตภัณฑ์เข้ามาในมุมมองและจัดตำแหน่งโลโก้',
      'productIdentified': 'ระบุผลิตภัณฑ์ แล้ว',
      'verificationInProgress': 'กําลังตรวจสอบ โปรดถือโทรศัพท์นิ่งๆ',
      'productGenuine': 'ผลิตภัณฑ์นี้ เป็นของแท้',
      'cannotConfirm': 'ลองอีกครั้ง',
      'unableToAuthenticate': 'ไม่สามารถตรวจสอบ ผลิตภัณฑ์ได้',
      'productNotInFocus': 'ผลิตภัณฑ์ไม่อยู่ในโฟกัส โปรดลองอีกครั้ง',
      'chooseLabel': 'เลือกประเภท ฉลาก',
      'startScanning': 'เริ่มการสแกน',
      'scanAgain': 'สแกนอีกครั้ง',
      'clearFocus': 'โฟกัสชัดเจนและพอดี = การตรวจสอบที่รวดเร็ว',
      'clearFocusDetail': 'วางผลิตภัณฑ์ในสภาพแวดล้อมที่มีแสงสว่างเพียงพอและตรวจสอบให้แน่ใจว่าไม่มีสิ่งของอื่นอยู่ในโฟกัส',
      'fastInternet': 'อินเทอร์เน็ตเร็ว = การตรวจสอบที่รวดเร็ว',
      'fastInternetDetail': 'ใช้การเชื่อมต่ออินเทอร์เน็ตที่เชื่อถือได้เพื่อผลลัพธ์ที่ดีที่สุด ความเร็วที่ช้ากว่าอาจทำให้การตรวจสอบล่าช้า',
      'genuine': 'ของแท้',
      'newVersionAvailable': 'มีเวอร์ชันใหม่พร้อมใช้งาน',
      'updateDescription': 'อัปเดตเพื่อผลลัพธ์ที่แม่นยำมากขึ้นและประสบการณ์การใช้แอปที่ราบรื่นมากขึ้น',
      'updateNow': 'อัปเดตตอนนี้',
      'later': 'ภายหลัง',
      'understoodStartScanning': 'เข้าใจ เริ่มการสแกน,',
      'poorInternetTitle': 'การเชื่อมต่ออินเทอร์เน็ตไม่ดี',
      'poorInternetDescription': 'เพื่อตรวจสอบผลิตภัณฑ์ได้อย่างน่าเชื่อถือ โปรดเปลี่ยนไปใช้การเชื่อมต่ออินเทอร์เน็ตที่ดีกว่า',
      'establishingConnection_1': 'กำลังสร้างการเชื่อมต่อ',
      'establishingConnection_2': 'รอสักครู่ เกือบเชื่อมต่อแล้ว',
      'establishingConnection_3': 'เกือบเสร็จแล้ว',
       'tryAgain': 'ลองอีกครั้ง'
  }
} as const;
export const XIAOMI_MODEL_CODES = [
  // Black Shark Series
  'SHARK KTUS-A0', 'SHARK PAR-A0',
  
  // POCO Series
  '220333QPG', '220333QPI', '220533QPI', '220733SPI',
  '23026RN54G', '23028RN4DG', '23028RN4DH', '23028RN4DI',
  '22127PC95X', '22127PC95I', '22127PC95G', '22127PC95H',
  '2310FPCA4G', '2310FPCA4I', 'M2004J11G', 'M2012K11AG',
  'MZB09C6IN', 'M2104K10I', '22021211RG', '21121210G',
  '21121210I', '22011211G', '23049PCD8G', '23049PCD8I',
  '23013PC75G', '23013PC75I', 'M2003J6CI', 'M2004J19PI',
  'M2010J19CG', 'M2010J19CT', 'M2010J19CI', 'M2103K19PI',
  '22041219PG', '22041219PI', '2201117SG', '21091116AG',
  '22071219CI', '2207117BPG', '23076PC4BI', '2312FPCA6G',
  '21061110AG', 'M2007J20CG', 'M2007J20CT', 'M2007J20CI',
  'M2102J20SG', 'M2102J20SI', '22041216G', '22041216UG',
  '2201116PG', '2201116PI', '22111317G', '22101320G',
  '22101320I', '23122PCD1G', '23122PCD1I', '2311DRK48G',
  '2311DRK48I', 'M1805E10A',
  
  // Redmi Series
  '2013023', 'MZB4123IN', 'L1680A P085-AHM2A',
  '2014817', '2014819', '2014811', '2014821', '2014812',
  'wt86047', 'MZB5602IN', 'BN35', 'MCI3B',
  'M1804C3DG', 'M1804C3DH', 'M1804C3DI',
  'M1805D1SI', 'M1805D1SE', 'M1805D1ST', 'M1805D1SC',
  'M1804C3CI', 'M1810F6LG', 'M1810F6LH', 'M1810F6LI',
  'M1903C3EG', 'M1903C3EI', 'M1903C3EE', 'M1903C3ET', 'M1903C3EC',
  'M1908C3IC', 'M1908C3II', 'M1908C3KG', 'M1908C3KH', 'M1908C3KI', 'M1908C3KE',
  'M2001C3K3I', 'M2006C3MII', 'M2004J19AG', 'M2004J19C', 'M2004C3MI', 'M2003J15SI',
  'MZB0A0NIN', 'M2010J19SI', 'M2004J19I', 'M2006C3LG', 'M2006C3LC',
  'M2006C3LI', 'M2006C3MG', 'M2006C3MT', 'M2006C3MNG',
  'M2006C3LII', 'MZB0BQJIN', 'MZB0A5HIN',
  'M2010J19SG', 'M2010J19SR', 'M2010J19ST',
  '21061119AG', '21061119DG', '21061119AL', '21121119SG', '21121119VL',
  '22041219G', '220333QBI', '220333QAI', '21061119BI', '22011119TI',
  '22041219I', '220233L2G', '220233L2I', '220233L2C',
  '220333QAG', '220333QNY', 'M2003J15SC', 'M2004J7AC', 'M2004J7BC',
  '22071219AI', '23053RN02Y', '23076RN8DY', '23076RA4BR', '23076RN4BI',
  '2212ARNC4L', '22120RN86I', '22120RN86H', '22120RN86C', '22126RN91Y', '22120RN86G',
  '23106RN0DA', '2311DRN14I', '23100RN82L', '23124RN87G', '23124RN87I', '23124RN87C',
  '220733SG', '220733SI', '220733SL', '220733SFG',
  'M1903C3GG', 'M1903C3GH', 'M1903C3GI',
  
  // Redmi K Series
  'M1903F10I', 'M1903F11A', 'M1903F11C', 'M1912G7BE', 'M1912G7BC',
  'M2001G7AE', 'M2004J11C', 'M2006J10C', 'M2001G7AC', 'M2007J3SC',
  'M2012K11AC', 'M2012K10C', '22021211RC', '22041211AC',
  '21121210C', '22011211C', '22081212C', '22041216I', '22041216UI',
  '23013RK75C', '23013PC75G', '23013PC75I', '22127RK46C', '23078RKD5C',
  '22122RK93C', '23113RKC6C', '23117RK66C', '2311DRK48C',
  
  // Redmi Note Series
  '2014912', '2014915', '2014911', '2014916', '2014910',
  '2015051', '2015712', '2015052', '2015055', '2015056',
  '2015116', '2015112', '2015115', '2015617', '2015611',
  'MZB5254IN', 'MZB5545IN', '2016050', '2016051', 'MBE6A5', 'MBT6A5',
  '2014715', '2014712', '2014021', '2014022', '2016101', '2016130',
  'MEG7', 'MEE7', 'MET7', 'MEI7', 'M1803E7SG', 'M1803E7SH', 'MEI7S', 'MEE7S', 'MET7S', 'MEC7S',
  'M1806E7TG', 'M1806E7TH', 'M1806E7TI', 'M1901F7G', 'M1901F7H', 'M1901F7I',
  'M1901F7S', 'M1908C3JH', 'M1908C3JI', 'M1908C3JE', 'M1908C3JC',
  'M1908C3JGG', '2015105', 'M1906G7I', 'M1906G7G', 'M1908C3XG',
  'M2003J15SC', 'M2003J15SS', 'M2003J15SI', 'M2003J15SG', 'M2007J22C',
  'M2003J6A1I', 'M2003J6B1I', 'M2007J17C', 'M2003J6A1G', 'M2003J6A1R',
  'M2007J22G', 'M2101K7AG', 'M2101K7AI', 'M2103K19G', 'XGIO2',
  '2109106A1I', 'M2101K6G', 'M2101K7BNY', 'M2101K7BG', 'M2101K7BI',
  'M2103K19I', 'A101XM', '22021119KR', '2201117TG', '2201117TI', '2201117TY', '2201117TL',
  '21121119SC', '21091116C', '2201116TG', '2201116TI', '2201116SG',
  '21091116UC', '21091116UG', '2201116SI', '22087RA4DI', '22041219C',
  '2201116SC', '2201117SY', '2201117SG', '2201117SI', '2201117SL',
  '22031116BG', '21091116AI', '22041216C', '22041216UC',
  '22101317C', '22111317G', '22111317I', '23021RAAEI', '23021RAAEG', '23028RA60L',
  '22101316UC', '22101316UG', '22101316UP', '23021RAA2Y',
  '22101316C', '22101316G', '22101316I', '2209116AG', '22101316UCP',
  '23049RAD8C', '23076RA4BC', '22111317I', '2303CRA44A', '23030RAC7Y', '2303ERA42L',
  '23054RA19C', '23129RAA4G', '23129RA5FL', '23124RA7EO',
  '2312DRAABC', '2312DRAABI', '2312DRAABG', '2312DRA50C', '2312DRA50G', '2312DRA50I', '2312CRAD3C',
  '23117RA68G', '23090RA98G', '23090RA98I', '2311FRAFDC',
  
  // Redmi Pad
  '22081283G', '22081283C', '23073RPBFG', '23073RPBFC', '23073RPBFL',
  
  // Redmi S2/Y Series
  'M1803E6H', 'M1803E6G', 'M1803E6I', 'M1803E6E', 'M1803E6T', 'M1803E6C',
  'M1810F6G', 'M1810F6I',
  
  // Xiaomi 11 Series
  '2109119DG', '2109119DI', '21091116I', '21091116UI', '21081111RG',
  '2107113SG', '2107113SI', '2107113SR', '2201123C', '2201123G',
  '2203129G', '2201122C', '2201122G', '2207122MC', '2206123SC',
  '2206122SC', '2203121C', '22071212AG', '22081212G',
  '2112123AC', '2112123AG',
  
  // Xiaomi 13 Series
  '2211133C', '2211133G', '2210129SG', '2210132C', '2210132G',
  '2304FPN6DG', '2304FPN6DC', '2306EPN60G', '23078PND5G', '23088PND5R',
  
  // Xiaomi 14 Series
  '23127PN0CC', '23127PN0CG', '23116PN5BC', '23116PN5BG',
  
  // Xiaomi CC/Civi Series
  'M1904F3BG', 'M1904F3BC', 'M1906F9SC', '2109119BC', '2204119EC',
  '2209129SC', '23046PNC9C',
  
  // Xiaomi Mi 10 Series
  'M2001J2G', 'M2001J2I', 'M2001J2C', 'M2001J2E', 'M2002J9G', 'M2002J9S',
  'MZB9038EU', 'M2001J1G', 'M2007J1SC', 'M2002J9E', 'M2007J17I',
  'M2102J2SC', 'M2007J3SY', 'M2007J17G', 'M2007J3SG', 'M2007J3SP', 'M2007J3SI', 'M2007J17C',
  
  // Xiaomi Mi 11 Series
  'M2011K2G', 'M2011K2C', '2107119DC', 'M2101K9G', 'M2101K9C', 'M2101K9R',
  'M2012K11G', 'M2012K11AI', 'M2012K11I',
  
  // Xiaomi Mi Legacy Series (1-9)
  '2012061', '2012062', '2013012', '2013021', '2012121',
  '2013062', '2013063', '2014218', '2014216', '2014719',
  '2015561', '2015562', '2015015', '2015911', '2015105', '2015201', '2015628',
  '2016089', '2015711', '2016070', 'MDE2', 'MDT2', 'MCE16', 'MCT1',
  'M1804D2SE', 'M1804D2ST', 'M1804D2SC', 'M1803E1A', 'M1803E1T', 'M1803E1C',
  'M1807E8S', 'M1807E8A', 'M1805E2A', 'M1902F1G', 'M1902F1C', 'M1902F1A', 'M1902F1T',
  'M1908F1XE', 'M1903F2G', 'M1903F2A', 'M1903F10G', 'MZB8017EU',
  
  // Xiaomi Mi A Series
  'MDG2', 'M1804D2SG', 'M1804D2SI', 'M1805D1SG', 'M1906F9SH', 'M1906F9SI',
  
  // Xiaomi Mi Max Series
  '2016002', '2016001', 'MDE40', 'MDT4', 'MDI40', 'M1804E4A', 'M1804E4T', 'M1804E4C',
  
  // Xiaomi Mi Mix Series
  '2016080', 'MDE5', 'MDT5', 'MDE5S', 'M1803D5XA', 'M1803D5XE', 'M1803D5XT', 'M1803D5XC',
  'M1810E5A', 'M1810E5E', '22061218C', '2308CPXD0C', '2106118C',
  
  // Xiaomi Mi Note Series
  '2015011', '2014616', '2014619', '2014618', '2014617',
  'M1910F4G', 'M2002F4LG', 'M1910F4S', 'B07N6QW7G1',
  
  // Xiaomi Mi Pad Series
  '2015716', 'MCE91', 'M1806D9W', 'M1806D9E', 'M1806D9PE',
  '21051182G', '21051182C', '22081281AC', 'M2105K81AC',
  '23043RP34G', '23043RP34C', '2307BRPDCC', '23046RP50C',
  
  // Xiaomi Mi Play
  'M1901F9E', 'M1901F9T'
];
export const { 
  CAMERA,
  CROSS_ICON,
  ERROR_ICON,
  FOCUS,
  KNOW_MORE,
  PHONE,
  SIGNAL,
  VIDEO, 
  WEBSITE,
  FOLLOW_US,
  CONTACT_US,
  LOADER_IMAGE_URL
 } = assets;
export default assets;
